var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZigZag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 93,
    viewBox: "0 0 89 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 93,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1153_2894)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -733,
    y: -889,
    width: 1512,
    height: 982,
    rx: 10,
    fill: "url(#paint0_linear_1153_2894)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.469163,
    d: "M1.50635 104.263C5.76233 99.1602 12.6397 104.897 16.8957 99.7941C21.1517 94.6916 14.2743 88.9552 18.5303 83.8527C22.7862 78.7502 29.6636 84.4865 33.9096 79.396C38.1657 74.2933 31.2884 68.557 35.5342 63.4666C39.7903 58.3639 46.6677 64.1003 50.9136 59.0099C55.1696 53.9073 48.2923 48.1709 52.548 43.0687C56.8041 37.9661 63.6815 43.7024 67.9375 38.5998C72.1933 33.4976 65.3159 27.7612 69.572 22.6586C73.8281 17.556 80.7054 23.2923 84.9615 18.1897C89.2173 13.0875 82.3399 7.35109 86.596 2.24847",
    stroke: "#111111",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1153_2894",
    x1: 23,
    y1: -889,
    x2: 23,
    y2: 93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474002,
    stopColor: "#EAEDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D4E1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1153_2894"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -733,
    y: -889,
    width: 1512,
    height: 982,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZigZag);
export default __webpack_public_path__ + "static/media/zig-zag.50b720feb85fbf2930dcc5e00952b40d.svg";
export { ForwardRef as ReactComponent };